const state = {
  selectedProducts: []
};

const mutations = {
  addProduct(state, product) {
    state.selectedProducts.push(product);
  },
  clearProducts(state) {
    state.selectedProducts = [];
  },
  updateProductName(state, { selectedProduct, name }) {
    selectedProduct.name = name;
  },
  updateProductPrice(state, { selectedProduct, price }) {
    selectedProduct.price = price;
  },
  updateProductQty(state, { selectedProduct, qty }) {
    selectedProduct.qty = qty;
  },
  removeProduct(state, index) {
    console.log('index')
    console.log(index)
    state.selectedProducts.splice(index, 1);
  },
};

const actions = {
  addProduct({ commit }, product) {
    commit('addProduct', product);
  },
  fetchProducts({ commit }, order_id){
      axios
          .get("/api/admin/offer?order_id="+order_id, 
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((res) => {
              if (res.data.status == "Success") {
                  commit('clearProducts');
                  res.data.data.forEach(product => {
                      commit('addProduct', product);
                  });
              }
          })
    
  },
  removeProduct({ commit, state }, productToRemove) {
      commit('removeProduct', productToRemove);
  },
};

const getters = {
  selectedProducts(state) {
    return state.selectedProducts;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
